import React from 'react'
import styled, { css } from 'styled-components';

const SectionHeader = styled.h1`
  text-align: center;
  font-weight: 300;
  color: ${props =>
    (props.light && 'white')
    || '#333'
  };

  @media (max-width: 600px) {
    font-size: 2rem;
  }
`;

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/Shared/SectionHeader.js